<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{title}} ({{data.length}})
          </h3>
        </div>
        <div class="col text-right">
          <div class="row align-items-right">
            <SearchBox v-model="searchTerm" class="search-box"/>
            <base-button
              type="success"
              size="sm"
              icon="ni ni-fat-add"
              @click="$emit('addPlayer')"
            >
              Add Player
            </base-button>
          </div>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="tableData">
        <template slot="columns">
          <th @click="setSortKey('Name')">
            <i class="fa fa-caret-up" v-if="sortKey === 'Name' && sortAsc"/>
            <i class="fa fa-caret-down" v-if="sortKey === 'Name' && !sortAsc"/>
            Name
          </th>
          <th @click="setSortKey('lastCompletedWeek.WeekNumber')">
            <i class="fa fa-caret-up" v-if="sortKey === 'lastCompletedWeek.WeekNumber' && sortAsc"/>
            <i class="fa fa-caret-down" v-if="sortKey === 'lastCompletedWeek.WeekNumber' && !sortAsc"/>
            Last Week Played
          </th>
          <th @click="setSortKey('handicap')">
            <i class="fa fa-caret-up" v-if="sortKey === 'handicap' && sortAsc"/>
            <i class="fa fa-caret-down" v-if="sortKey === 'handicap' && !sortAsc"/>
            Handicap
          </th>
          <th @click="setSortKey('paid')">
            <i class="fa fa-caret-up" v-if="sortKey === 'paid' && sortAsc"/>
            <i class="fa fa-caret-down" v-if="sortKey === 'paid' && !sortAsc"/>
            Payment Status
          </th>
          <th @click="setSortKey('tooniePot')">
            <i class="fa fa-caret-up" v-if="sortKey === 'tooniePot' && sortAsc"/>
            <i class="fa fa-caret-down" v-if="sortKey === 'tooniePot' && !sortAsc"/>
            Toonie Pot
          </th>
          <th></th>
        </template>

        <template slot-scope="{row}">
          <th scope="row">
            <div class="media align-items-center">
              <div class="avatar rounded-circle">
                  <img alt="Image placeholder" :src="getAvatarUrl(row)">
              </div>
              <div class="name">
                <span class="name mb-0 text-sm">{{row.Name}}</span>
              </div>
            </div>
          </th>
          <td class="type" v-if="row.lastCompletedWeek !== null">
            <b>Week {{row.lastCompletedWeek.WeekNumber}}</b>
            <br/> {{row.lastCompletedWeek.course !== null ? row.lastCompletedWeek.course.Name : ''}}
          </td>
          <td class="type" v-else>
            <b>No Weeks Played</b>
          </td>
          <td class="handicap">
            {{Math.round(row.handicap)}}
          </td>
          <td>
            <i class="fa fa-check text-success" v-if="row.paid"/>
            <i class="fa fa-times text-deposit" v-else-if="row.deposit"/>
            <i class="fa fa-money-bill text-warning" v-else/>
            <span class="text-success" v-if="row.paid"> Paid In Full</span>
            <span class="text-deposit" v-else-if="row.deposit"> Awaiting Payment</span>
            <span class="text-warning" v-else> Paid Weekly</span>
          </td>
          <td class="handicap">
            <i class="fa fa-coins text-success" v-if="row.tooniePot"/>
            <i class="fa fa-coins text-warning" v-else/>
            <!--<span class="text-success" v-if="row.tooniePot"> Active</span>
            <span class="text-warning" v-else> Inactive</span>-->
          </td>
          <td class="text-right">
            <a
              class="btn btn-sm btn-icon-only text-light"
              role="button"
              @click.prevent="$emit('onEdit', row)"
            >
              <i class="fa fa-edit"></i>
            </a>
            <a
              class="btn btn-sm btn-icon-only text-light"
              role="button"
              @click.prevent="$emit('onRemove', row)"
            >
              <i class="fa fa-trash"></i>
            </a>
          </td>

        </template>

      </base-table>
    </div>

    <div class="card-footer d-flex justify-content-end"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <base-pagination
        :total="filteredData.length"
        :perPage="perPage"
        v-model="currentPage"
      />
    </div>

  </div>
</template>
<script>
import Fuse from 'fuse.js';
import AvatarHelper from '@/helpers/Avatars';
import SearchBox from '@/components/SearchBox.vue';

export default {
  name: 'LeaguePlayersTable',
  props: {
    type: {
      type: String,
    },
    title: String,
    data: {
      type: Array,
    },
    perPage: {
      type: Number,
      default: 10,
    },
  },
  components: {
    SearchBox,
  },
  data() {
    return {
      currentPage: 1,
      sortKey: 'Name',
      sortAsc: true,
      searchTerm: '',
    };
  },
  computed: {
    filteredData() {
      if (this.searchTerm.length > 0) {
        const options = {
          keys: ['Name'],
          threshold: 0.1,
        };

        const fuseSearch = new Fuse(this.data, options);
        const result = fuseSearch.search(this.searchTerm);
        return result
          .sort((a, b) => String(a.Name).localeCompare(b.Name));
      }
      return this.data;
    },
    tableData() {
      const startIndex = this.perPage * (this.currentPage - 1);
      const endIndex = this.perPage * this.currentPage;
      const sortMultiplier = this.sortAsc ? 1 : -1;

      const dataCopy = [...this.filteredData];

      return dataCopy.sort((a, b) => {
        if (this.resolve(this.sortKey, a) > this.resolve(this.sortKey, b)) {
          return 1 * sortMultiplier;
        }
        if (this.resolve(this.sortKey, b) > this.resolve(this.sortKey, a)) {
          return -1 * sortMultiplier;
        }
        return 0;
      }).slice(startIndex, endIndex);
    },
  },
  watch: {
    searchTerm() {
      if (this.searchTerm.length > 0) {
        this.currentPage = 1;
      }
    },
  },
  methods: {
    resolve(path, obj = self, separator = '.') {
      const properties = Array.isArray(path) ? path : path.split(separator);
      return properties.reduce((prev, curr) => prev && prev[curr], obj);
    },
    getAvatarUrl(user) {
      return AvatarHelper.getAvatar(user);
    },
    setSortKey(key) {
      if (key === this.sortKey) {
        this.sortAsc = !this.sortAsc;
      } else {
        this.sortKey = key;
      }
    },
  },
};
</script>
<style type="scss" scoped>
  .type{
    text-transform: capitalize;
  }
  .name{
    cursor: pointer;
  }
  .avatar{
    margin-right: 1rem;
  }
  .avatar img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  th{
    cursor: pointer;
  }
  .handicap{
    text-align: center;
  }
  .text-deposit {
    color: #f39c12;
  }
  .search-box {
    margin-right: 1rem;
  }
  .align-items-right {
    justify-content: flex-end;
    margin-right: 0rem;
  }
</style>
